export const STUDENT_PASSWORD_UPDATE_SUCCESS = "Student Password updated successfully";
export const ASSIGNMENT_SUBMITTED_SUCCESSFULLY = "Assignment Submitted Successfully";
export const BLOCKLY_FILE_UPLOADED_SUCCESSFULLY = "Blockly File uploaded successfully";
export const PROFILE_UPDATED_SUCCESSFULLY = "Profile updated successfully";
export const CLASS_LINK_UPDATED_SUCCESSFULLY = "Class Link updated successfully";
export const PROFILE_PHOTO_UPDATED_SUCCESSFULLY = "Profile photo updated successfully";
export const USER_DELETED_SUCCESSFULLY = "User deleted successfully";
export const USER_PASSWORD_UPDATED_SUCCESSFULLY = "User Password updated successfully";
export const USER_CREATED_SUCCESSFULLY = "User created successfully";
export const SCHEDULE_UPDATED_SUCCESSFULLY = "Schedule updated successfully";
export const TEACHER_ONBOARDED_SUCCESSFULLY = "Teacher onboarded successfully";
export const COURSE_REVIEW_COMPLETED_SUCCESSFULLY = "Course review completed successfully";
export const STUDENT_ONBOARDED_SUCCESSFULLY = "Student onboarded successfully";
export const RESOURCE_UPDATED_SUCCESSFULLY = "Resource updated successfully";
export const RESOURCE_CREATED_SUCCESSFULLY = "Resource created successfully";
export const SOURCE_ADDED_SUCCESSFULLY = "Source added successfully";
export const RESOURCE_PUBLISHED_SUCCESSFULLY = "Resource published successfully";
export const RESOURCE_DELETED_SUCCESSFULLY = "Resource deleted successfully";
export const RESOURCE_BLOCKED_SUCCESSFULLY = "Resource blocked successfully";
export const RESOURCE_UNBLOCKED_SUCCESSFULLY = "Resource unblocked successfully";
export const QUESTION_DELETED_SUCCESSFULLY = "Question deleted successfully";
export const QUESTION_UPDATED_SUCCESSFULLY = "Question updated successfully";
export const QUESTION_CREATED_SUCCESSFULLY = "Question created successfully";
export const QUIZ_COPIED_SUCCESSFULLY = "Quiz copied successfully";
export const QUIZ_DELETED_SUCCESSFULLY = "Quiz deleted successfully";
export const QUIZ_PUBLISHED_SUCCESSFULLY = "Quiz Published successfully";
export const QUIZ_UPDATED_SUCCESSFULLY = "Quiz updated successfully";
export const QUIZ_CREATED_SUCCESSFULLY = "Quiz created successfully";
export const PLAN_CREATED_SUCCESSFULLY = "Plan created successfully";
export const ORGANIZATION_CREATED_SUCCESSFULLY = "Organization created successfully";
export const PLAN_SUBSCRIBED_SUCCESSFULLY = "Plan subscribed successfully";
export const PLAN_RECHARGED_SUCCESSFULLY = "Plan recharged successfully";
export const NOTES_MOVED_SUCCESSFULLY = "Notes moved successfully";
export const NOTE_SAVED_SUCCESSFULLY = "Note saved successfully";
export const RESOURCE_ADDED_SUCCESSFULLY = "Resource added successfully";
export const NOTE_DELETED_SUCCESSFULLY = "Note deleted successfully";
export const USER_PASSWORD_CHANGED_SUCCESSFULLY = "User Password changed successfully";

// Error Messages
export const FAILED_TO_JOIN_CLASS = "Failed to join class. Please try again.";
export const CLASS_NOT_STARTED_YET = "Class Not Started Yet !";
export const PLEASE_COMPLETE_STARTED_CLASS_FIRST = "Please complete started class first";
export const CLASS_NOT_STARTED_YET_EXCLAIM = "Class Not Started Yet!";
export const RECORDING_NOT_YET_PUBLISHED = "Recording is not yet published.";
export const FAILED_TO_FETCH_RECORDINGS = "Failed to fetch recordings. Please try again.";
export const COURSE_REVIEW_PENDING_BOTH = "Course Review is Pending with Student and Teacher";
export const COURSE_REVIEW_PENDING_STUDENT = "Course Review is Pending with Student";
export const COURSE_REVIEW_PENDING_TEACHER = "Course Review is Pending with Teacher";
export const CERTIFICATE_NOT_GENERATED = "Certificate is not generated.";
export const NO_CONTENT_IN_COURSE = "There is no Content in the Course";
export const ALREADY_ATTEMPTED = "Already Attempted , Please refresh";
export const PASSWORDS_DONT_MATCH = "Passwords don't match";
export const MIN_MAX_SLOTS_BOOKING = "Minimum 2 and Maximum 4 slots can be booked";
export const NO_NOTES_IN_COURSE = "There is no Notes in the Course";
export const CODE_TAKING_MORE_TIME = "Code is Taking more time , please optimize";
export const TEACHER_SLOT_ALREADY_BOOKED = "Teacher Slot is already booked";
export const TIMINGS_NOT_AVAILABLE_TO_COPY = "Timings are not available to Copy";
export const BOOKING_SLOT_11_30_PM_NOT_ALLOWED = "Booking slot at 11:30 PM is not allowed";
export const TIME_SLOT_OVERLAPS = "Selected time slot overlaps with an existing one";